import { render } from "./LoadingDots.vue?vue&type=template&id=ed6a1d32"
import script from "./LoadingDots.vue?vue&type=script&lang=js"
export * from "./LoadingDots.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__